import { useUserDetailsGlobalStore } from '@marriott/mi-store-utils';
import clsx from 'clsx';
import React, { ReactNode } from 'react';
import { useNavContext } from '../../../organisms/NavigationContainer';
import { DEFAULT_TRACKING_VALUES } from '../../../utils/constants';
import { getClickTrackValue } from '../../../utils/TrackingPropertyUtils';
import { RestPropType } from '../NavigationUtilityLink';

export type MyTripsProps = {
  children: ReactNode;
  restProps: RestPropType;
  trackingContentPosition: string | undefined;
  buttonClassName?: string;
};

export const MyTrips = (props: MyTripsProps) => {
  const { children, restProps, trackingContentPosition, buttonClassName } = props;
  const { setIsMyTripsModalOpen } = useNavContext();
  const userProfileData = useUserDetailsGlobalStore(state => state);
  const isSignedInUser = useUserDetailsGlobalStore(state => state?.isSignedInUser);
  const myTripsCount = userProfileData?.trips?.upcomingReservationsCount || 0;

  const handleMyTripsClick = () => {
    setIsMyTripsModalOpen(true);
  };

  const panelTitle = restProps['cq:panelTitle'] || restProps?.resourceProperties['cq:panelTitle'];
  const propsObj = {
    className: clsx('utility-mytrips-button t-label-inverse-xs custom_click_track', buttonClassName),
    'data-custom_click_track_value': getClickTrackValue({
      trackingProperties: {
        trackingContentPosition,
      },
      url: restProps['cq:panelUrl'],
      fallbacks: {
        description: restProps['cq:panelTitle'],
        position: DEFAULT_TRACKING_VALUES.GLOBAL_NAV,
      },
    }),
    'aria-label': `${panelTitle}${myTripsCount > 0 ? ` (${myTripsCount})` : ''}`,
  };

  const handleMyTripsKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handleMyTripsClick();
    }
  };

  return isSignedInUser ? (
    <a {...propsObj} href={userProfileData?.trips?.url}>
      {children}
      {/* Reverting the trips count from header temporarily - WEB-151755
       {myTripsCount > 0 && (
        <span aria-hidden="true" className="utility-link-text d-none d-xl-inline-block">
          ({myTripsCount})
        </span>
      )}  */}
    </a>
  ) : (
    <button
      {...propsObj}
      id="utility-mytrips-trigger"
      onClick={handleMyTripsClick}
      onKeyDown={handleMyTripsKeyDown}
      type="button"
    >
      {children}
    </button>
  );
};
